import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material';
import { EvadocInfoDto } from 'src/app/dto/evadoc-info-dto';
import { ParesDto } from 'src/app/dto/pares-dto';
import { PersonaDto } from 'src/app/dto/persona-dto';
import { CursoService } from 'src/app/services/curso.service';
import { DocenteService } from 'src/app/services/docente.service';
import { EvadocDocenteService } from 'src/app/services/evadoc-docente.service';
import { EvaluarDocentexDocenteService } from 'src/app/services/evaluar-docentex-docente.service';
import { UaaService } from 'src/app/services/uaa.service';
import { ParesDialogComponent } from '../pares-dialog/pares-dialog.component';
import { CorreoParDto } from 'src/app/dto/correo-par-dto';
import { DocentesDependenciaUaaDto } from 'src/app/dto/docentes-dependencia-uaa-dto';
import { distinctUntilChanged, take } from 'rxjs/operators';

@Component({
  selector: 'app-asignar',
  templateUrl: './asignar.component.html',
  styleUrls: ['./asignar.component.css']
})
export class AsignarComponent implements OnInit {

  lstPares: ParesDto[] = [];
  listaParaFiltrar: EvadocInfoDto[]
  par: DocentesDependenciaUaaDto[];
  lstDocenteDependenciaUaaDto: DocentesDependenciaUaaDto[];
  lstEvaluador: DocentesDependenciaUaaDto[];

  constructor(
    private uaaService: UaaService,
    private evaDocService: EvadocDocenteService,
    private doxXDocSservice: EvaluarDocentexDocenteService,
    public dialog: MatDialog,
    private docenteService: DocenteService,
    private curso: CursoService,
  ) { }

  ngOnInit() {
    this.listar();
    this.buscar();
  }

  listar() {
    this.listaParaFiltrar = [];
    this.uaaService.currentData
      .pipe(distinctUntilChanged((prev, curr) => prev.uaa === curr.uaa))
      .subscribe((data) => {

        if (data.uaa) {
          this.evaDocService.obtenerDocentesUaa(data.uaa).subscribe((data: EvadocInfoDto[]) => {
            this.listaParaFiltrar = data;
            this.listarEvaluadorPorPersona();
          });
        }
      });
  }

  buscar() {
    this.uaaService.currentData.subscribe((datos) => {
      this.docenteService.obtenerDocentes().subscribe((data: DocentesDependenciaUaaDto[]) => {
        this.par = data;
        data = data.filter(pa =>
          pa.codigoPersona !== datos.personaCodigo
        )
        this.lstDocenteDependenciaUaaDto = data.filter(docente => {
          let flag = true;
          for (const docenteE of this.listaParaFiltrar) {
            if (docenteE.docente.codigo == docente.codigoPersona) {
              flag = false;
              break;
            }
          }
          return flag;
        });
        this.lstEvaluador = data;
      });
    })
  }

  listarEvaluadorPorPersona() {
    this.lstPares = [];
    if (this.listaParaFiltrar && Array.isArray(this.listaParaFiltrar)) {
      this.listaParaFiltrar.forEach(element => {

        this.doxXDocSservice.listarEvaluadorPorPersona(element.docente.codigo).subscribe((data: PersonaDto[]) => {
          let pares: ParesDto = new ParesDto();
          pares.evaluado = element;
          pares.evaluador = data[0];

          this.uaaService.currentData.subscribe((datos) => {
            if (pares.evaluador != null) {
              this.curso.validarEvaluacion(data[0].persona.identificacion, element.docente.codigo, datos.periodo).subscribe((bool) => {
                pares.validarEvaluacion = bool;
              });
            }
          })
          this.lstPares.push(pares);
        });
      });
    }
  }

  agregarClick(element: ParesDto) {
    this.uaaService.currentData.pipe(take(1)).subscribe((data) => {
      const dialogRef = this.dialog.open(ParesDialogComponent, {
        maxWidth: '100vw',
        width: window.innerWidth < 576 ? '100vw' : '600px',
        maxHeight: '100vh',
        height: window.innerWidth < 576 ? '100vh' : 'auto',
        disableClose: true,
        data: {
          docente: element,
          periodo: data.periodo,
          accion: 'Agregar',
          evaluadores: this.par,
          evaluado: element.evaluado.docente.codigo,
          periodoEvaluacion: element.evaluado.periodo
        }
      });

      dialogRef.afterClosed().subscribe(result => {
        this.listar();
        if (result !== null && result !== undefined && result !== true) {
          let email: CorreoParDto = new CorreoParDto();
          email.correoEvaluador = result;
          email.periodo = data.periodoNombre;
          email.nombreEvaluado = element.evaluado.docente.apellido + ' ' + element.evaluado.docente.nombre
          this.docenteService.emailEvaluacion(email).subscribe(data => {
          })
        }
      });
    })
  }

  editarClick(element: ParesDto) {
    this.uaaService.currentData.pipe(take(1)).subscribe((data) => {
      const dialogRef = this.dialog.open(ParesDialogComponent, {
        maxWidth: '100vw',
        width: window.innerWidth < 576 ? '100vw' : '600px',
        maxHeight: '100vh',
        height: window.innerWidth < 576 ? '100vh' : 'auto',
        disableClose: true,
        data: {
          docente: element,
          periodo: data.periodo,
          accion: 'Editar',
          evaluadores: this.par,
          evaluado: element.evaluado.docente.codigo,
          periodoEvaluacion: element.evaluado.periodo
        }
      });

      dialogRef.afterClosed().subscribe(evaluado => {
        if (evaluado !== null && evaluado !== undefined && evaluado !== true) {
          let email: CorreoParDto = new CorreoParDto();
          email.correoEvaluador = evaluado;
          email.periodo = data.periodoNombre;
          email.nombreEvaluado = element.evaluado.docente.apellido + ' ' + element.evaluado.docente.nombre;
          this.docenteService.emailEvaluacion(email).subscribe(data => {
          });
        }
        this.listar();
      });
    })
  }
}